import { gradientStore, getGradientColors } from './gradient-store.js';

export function initLogoResponsiveness() {
  let currentViewBox = '0 0 750 78';

  function updateLogo() {
    const logo = document.getElementById('logo-svg');
    const logoTop = document.getElementById('logo-svg-top');

    if (!logo || !logoTop) {
      return;
    }

    const containerWidth = logo.clientWidth;

    if (containerWidth < 600) {
      // Mobile mode - implement cropping to maintain height
      const originalWidth = 750;
      const originalHeight = 78;
      const visibleWidth = containerWidth;
      const cropAmount = (originalWidth - visibleWidth) / 2;

      const newViewBox = `${cropAmount} 0 ${visibleWidth} ${originalHeight}`;

      currentViewBox = newViewBox;

      // Apply the cropping to both SVGs
      logo.setAttribute('viewBox', newViewBox);
      logoTop.setAttribute('viewBox', newViewBox);

      // Only modify background rects, not gradient rects (to avoid interfering with color party)
      const backgroundRects = logo.querySelectorAll('rect:not([mask]):not([filter])');
      const backgroundRectsTop = logoTop.querySelectorAll('rect:not([mask]):not([filter])');

      backgroundRects.forEach(rect => {
        rect.setAttribute('x', cropAmount);
        rect.setAttribute('width', visibleWidth);
      });

      backgroundRectsTop.forEach(rect => {
        rect.setAttribute('x', cropAmount);
        rect.setAttribute('width', visibleWidth);
      });
    } else {
      // Desktop mode - reset to full logo
      currentViewBox = '0 0 750 78';
      logo.setAttribute('viewBox', '0 0 750 78');
      logoTop.setAttribute('viewBox', '0 0 750 78');

      // Reset only background rects to original coordinates
      const backgroundRects = logo.querySelectorAll('rect:not([mask]):not([filter])');
      const backgroundRectsTop = logoTop.querySelectorAll('rect:not([mask]):not([filter])');

      backgroundRects.forEach(rect => {
        rect.setAttribute('x', '0');
        rect.setAttribute('width', '750');
      });

      backgroundRectsTop.forEach(rect => {
        rect.setAttribute('x', '0');
        rect.setAttribute('width', '750');
      });
    }
  }

  // Function to get current viewBox for color calculations
  function getCurrentViewBox() {
    return currentViewBox;
  }

  // Subscribe to Redux store for color updates
  function updateLogoColors() {
    const state = gradientStore.getState();

    // Skip update if animation is disabled
    if (!state.animationEnabled) {
      return;
    }

    const { primaryColor, peekColor } = getGradientColors(state);

    // Apply colors to logo gradient stops
    const logo = document.getElementById('logo-svg');
    const logoTop = document.getElementById('logo-svg-top');

    if (logo && logoTop) {
      // Find gradient definitions
      const gradBottom = logo.querySelector('#gradBottom');
      const gradTop = logoTop.querySelector('#gradTop');

      if (gradBottom) {
        const stops = gradBottom.querySelectorAll('stop');

        if (stops.length >= 2) {
          stops[0].setAttribute(
            'stop-color',
            `hsl(${primaryColor.h}, ${primaryColor.s}%, ${primaryColor.l}%)`
          );
          stops[1].setAttribute(
            'stop-color',
            `hsl(${peekColor.h}, ${peekColor.s}%, ${peekColor.l}%)`
          );
        }
      }

      if (gradTop) {
        const stops = gradTop.querySelectorAll('stop');

        if (stops.length >= 2) {
          stops[0].setAttribute(
            'stop-color',
            `hsl(${primaryColor.h}, ${primaryColor.s}%, ${primaryColor.l}%)`
          );
          stops[1].setAttribute(
            'stop-color',
            `hsl(${peekColor.h}, ${peekColor.s}%, ${peekColor.l}%)`
          );
        }
      }
    }
  }

  // Initial update
  updateLogo();
  updateLogoColors();

  // Update on resize
  window.addEventListener('resize', updateLogo);

  // Subscribe to Redux store for color updates
  gradientStore.subscribe(updateLogoColors);

  // Export functions for external use
  return {
    getCurrentViewBox,
    updateLogo,
  };
}
